var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityCube1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cube_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.084 21.805l3.166 1.131v-4.406l-3.166-1.131z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.416 20.139l3.168 1.131v-4.408l-3.168-1.129z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.607 6.15l-2.467 0.881 2.467 0.881 2.467-0.881z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.084 27.805l3.166 1.131v-4.406l-3.166-1.131z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.303 7.828l-2.467 0.881 2.469 0.881 2.467-0.881z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.416 14.139l3.168 1.131v-4.346l-3.168-1.131z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.416 26.139l3.168 1.131v-4.408l-3.168-1.129z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.695 6.236l2.469-0.881-2.467-0.883-2.471 0.883z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.303 4.473l-2.467 0.883 2.469 0.881 2.469-0.881z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.533 7.031l2.467 0.881 2.467-0.881-2.467-0.881z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 24.473l3.166 1.129v-4.406l-3.166-1.131z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12.473l3.166 1.129v-4.344l-3.166-1.131z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.467 3.678l-2.467-0.881-2.467 0.881 2.467 0.881z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 18.473l3.166 1.129v-4.406l-3.166-1.131z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.393 6.15l-2.467 0.881 2.467 0.881 2.467-0.881z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.416 15.27l3.168-1.131v-4.346l-3.168 1.131z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.416 21.27l3.168-1.131v-4.406l-3.168 1.129z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.084 25.602l3.166-1.129v-4.408l-3.166 1.131z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.084 19.602l3.166-1.129v-4.408l-3.166 1.131z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 8.127l-3.166 1.131v4.344l3.166-1.129z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.084 15.805l3.166 1.131v-4.346l-3.166-1.129z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 22.935l3.166-1.131v-4.406l-3.166 1.131z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 28.935l3.166-1.131v-4.406l-3.166 1.131z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.504l-2.469 0.881 2.469 0.883 2.469-0.883z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16.936l3.166-1.131v-4.344l-3.166 1.129z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.697 7.828l-2.469 0.881 2.467 0.881 2.469-0.881z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.416 27.27l3.168-1.131v-4.406l-3.168 1.129z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityCube1);
export default __webpack_public_path__ + "static/media/unity_cube_1.6188e6472ecd02f8c0a5a0d050f1e3fb.svg";
export { ForwardRef as ReactComponent };